import TabHomePage from "./screens/Tab&Desktop/TabHomePage";
import { useMediaQuery } from "react-responsive";
function App() {
  return <div>{<TabHomePage />}</div>;
}

export default App;
